import styled from "styled-components";

const StyledContainer = styled.div`
  background: ${({ token }) =>
    token.page_dashboard__card_quick_start_background};
  backdrop-filter: blur(6px);
  border-radius: 12px;
  border-top: 1px solid;
  border-top-color: rgba(255, 255, 255, 0.4);
  box-shadow:
    0 4px 4px 0 rgba(0, 0, 0, 0.25),
    0 8px 9px 0 rgba(0, 0, 0, 0.2);
  color: #fff;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 142px;
  justify-content: space-between;
  padding: 20px;
  transition: all 500ms;
  width: 100%;

  &:hover {
    border-top: 1px solid rgba(255, 255, 255, 0.8);
    background: ${({ token }) =>
      token.page_dashboard__card_quick_start_background_hover};
    box-shadow:
      0 7px 7px 0 rgba(0, 0, 0, 0.29),
      0 8px 9px 0 rgba(0, 0, 0, 0.2);
  }

  .label-quick-start {
    font-size: 12px;
    opacity: 0.6;
    margin: unset;
  }

  h5 {
    font-size: 20px;
    line-height: 24px;
    margin: 0;

    span {
      color: #88a6bd;
      font-weight: 400;
    }
  }
`;

export default StyledContainer;
